import { ZVANJA, OBVEZE, TRAJNO_INFO } from "../data/pravilnik";
import { BookOpenCheck, Info } from "lucide-react";

export const UvjetiPregled = () => (
  <section className="bg-white p-5 sm:p-6 rounded-xl shadow-sm border border-slate-200" data-testid="uvjeti-panel">
    <h2 className="text-lg font-semibold text-slate-800 font-heading mb-4">Pregled uvjeta za sva zvanja</h2>
    <div className="overflow-x-auto">
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="border-b-2 border-slate-200">
            <th className="text-left py-2.5 pr-4 text-xs font-bold uppercase tracking-wider text-slate-500">Uvjet</th>
            {Object.values(ZVANJA).map((z) => (
              <th key={z.id} className="text-left py-2.5 px-4 text-xs font-bold uppercase tracking-wider text-blue-600">
                {z.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="text-slate-700">
          <tr className="border-b border-slate-100">
            <td className="py-2.5 pr-4">Godine staža u školskoj ustanovi</td>
            <td className="py-2.5 px-4 font-semibold">5 (iznimno 3*)</td>
            <td className="py-2.5 px-4 font-semibold">10</td>
            <td className="py-2.5 px-4 font-semibold">15</td>
          </tr>
          <tr className="border-b border-slate-100">
            <td className="py-2.5 pr-4">Sati stručnog usavršavanja (posljednjih 5 god.)</td>
            <td className="py-2.5 px-4 font-semibold">100</td>
            <td className="py-2.5 px-4 font-semibold">120</td>
            <td className="py-2.5 px-4 font-semibold">150</td>
          </tr>
          <tr className="border-b border-slate-100">
            <td className="py-2.5 pr-4">Godine u prethodnom zvanju</td>
            <td className="py-2.5 px-4 font-semibold">–</td>
            <td className="py-2.5 px-4 font-semibold">5 (mentor)</td>
            <td className="py-2.5 px-4 font-semibold">5 (savjetnik)</td>
          </tr>
          <tr className="border-b border-slate-100">
            <td className="py-2.5 pr-4">Minimalan broj bodova</td>
            <td className="py-2.5 px-4 font-semibold">20 (iznimno 40*)</td>
            <td className="py-2.5 px-4 font-semibold">40</td>
            <td className="py-2.5 px-4 font-semibold">60</td>
          </tr>
          <tr className="border-b border-slate-100">
            <td className="py-2.5 pr-4">Minimalan broj kategorija</td>
            <td className="py-2.5 px-4 font-semibold">3 (iznimno 4*)</td>
            <td className="py-2.5 px-4 font-semibold">4</td>
            <td className="py-2.5 px-4 font-semibold">5</td>
          </tr>
          <tr>
            <td className="py-2.5 pr-4">Obvezna kategorija</td>
            <td className="py-2.5 px-4 font-semibold" colSpan={3}>
              Unaprjeđivanje rada škole (za sva zvanja)
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p className="text-xs text-slate-500 mt-3">
      * Iznimka za mentora: najmanje 3 godine staža uz 40 bodova ostvarenih u najmanje 4 kategorije. Za sva
      zvanja obvezan je i položen stručni ispit (ako postoji ta obveza) te izvršene obveze prethodnog zvanja.
    </p>

    <div className="mt-6 bg-blue-50 border border-blue-100 rounded-xl p-4">
      <h3 className="flex items-center gap-2 text-sm font-semibold text-blue-800 mb-2">
        <Info size={16} /> Trajanje i obnavljanje zvanja
      </h3>
      <ul className="space-y-1.5">
        {TRAJNO_INFO.map((t, i) => (
          <li key={i} className="text-sm text-slate-700 flex gap-2">
            <span className="text-blue-500 shrink-0">•</span> {t}
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export const ObvezePregled = () => (
  <section className="bg-white p-5 sm:p-6 rounded-xl shadow-sm border border-slate-200" data-testid="obveze-panel">
    <h2 className="text-lg font-semibold text-slate-800 font-heading mb-1">Godišnje obveze u zvanju</h2>
    <p className="text-sm text-slate-500 mb-5">
      Nakon izbora u zvanje, radnik je dužan svake godine izvršavati sljedeće obveze. Neizvršavanje obveza
      prepreka je za obnavljanje ili napredovanje u više zvanje.
    </p>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {Object.entries(OBVEZE).map(([key, o]) => (
        <div key={key} className="border border-slate-200 rounded-xl p-4" data-testid={`obveze-${key}`}>
          <h3 className="flex items-center gap-2 text-sm font-bold text-slate-800 mb-3">
            <BookOpenCheck size={16} className="text-blue-600" /> {o.label}
          </h3>
          <ul className="space-y-2">
            {o.stavke.map((s, i) => (
              <li key={i} className="text-sm text-slate-600 flex gap-2 leading-snug">
                <span className="text-blue-500 shrink-0">•</span> {s}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </section>
);
